import { useCallback, useState } from "react";
import { handleAsync } from "../../utils/helpers/handleAsync";
type ConfirmState<T> = {
    open: boolean;
    payload: T | null;
};

type Options<T> = {
    onSuccess?: (payload: T) => void;
    onError?: (error: unknown) => void;
    showSuccessToast?: boolean
};

export const useConfirmAction = <T,>(options?: Options<T>) => {
    const [state, setState] = useState<ConfirmState<T>>({
        open: false,
        payload: null,
    });

    const [loading, setLoading] = useState(false);

    // open modal with payload
    const request = useCallback((payload: T) => {
        setState({
            open: true,
            payload,
        });
    }, []);

    // close modal
    // const close = useCallback(() => {
    //     setState({
    //         open: false,
    //         payload: null,
    //     });
    // }, []);

    const close = useCallback(() => {
        setState(prev => ({ ...prev, open: false }));
    }, []);

    // execute action
    const confirm = useCallback(
        async (action: (payload: T) => Promise<any>) => {
            // if (!state.payload) return;
            if (!state.open) return;

            setLoading(true);

            await handleAsync(
                async () => {
                    return await action(state.payload as T);
                },
                {
                    onSuccess: () => {
                        options?.onSuccess?.(state.payload as T);
                        close();
                    },
                    onError: (err) => {
                        options?.onError?.(err);
                    },
                    finallyCb: () => {
                        setLoading(false);
                    },
                    showSuccessToast: options?.showSuccessToast ?? true
                }
            );
        },
        [state.payload, options, close, state.open]
    );

    return {
        state,
        loading,
        request,
        close,
        confirm,
    };
};